module["exports"] = [
  "0# #### ####",
  "+61 # #### ####",
  "04## ### ###",
  "+61 4## ### ###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_au_ocker/phone_number/formats.js
// module id = 1221
// module chunks = 1